import AuthService from "@/services/AuthService";
import MyProfileService from "@/services/MyProfileService";

export default {
  namespaced: true,
  state: {
    user: null,
    isAuthenticated: false,
    isLoading: null,
    modelPermissionLoading: false,
    // Login-time wishes (birthday, anniversary, ...). Kept out of the cached
    // user so the popup shows once per login, not on every page refresh.
    celebrations: []

  },
  mutations: {
    saveUserData(state, payload) {
      const { celebrations, ...user } = payload || {};

      // mutate state
      state.user = user
      state.isAuthenticated = true;
      // Only a login response carries the key; re-saving the cached user (e.g.
      // checkAuth) must not wipe a popup that is still open.
      if (celebrations !== undefined) {
        state.celebrations = Array.isArray(celebrations) ? celebrations : [];
      }
      localStorage.setItem('user', JSON.stringify(user));
    },

    clearCelebrations(state) {
      state.celebrations = [];
    },

    authenticate(state, user) {
      state.isAuthenticated = true;
      state.user = user;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.celebrations = [];
      state.isLoading = false;
      state.modelPermissionLoading = false;
      localStorage.removeItem('user');
    },

    loading(state, payload) {
      state.isLoading = payload;
    },

    permissionsLoading(state, payload) {
      state.modelPermissionLoading = payload;
    },
    
    reset(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.isLoading = false;
      state.modelPermissionLoading = false;
    }

  },
  actions: {
    async checkAuth({ commit, state }) {
      const storedUser = JSON.parse(localStorage.getItem('user'));
      if (storedUser) {
        commit('saveUserData', storedUser);
        return;
      }
      try {
        commit('loading', true);
        commit('permissionsLoading', true)

        const response = await AuthService.checkAuth();
        console.log("response", response)

        if (!response.data?.client_id) {
          const profileResponse = await MyProfileService.getUserProfile();
          // this.userProfile = response.data;
          console.log("userProfile", this.userProfile)

          if(profileResponse.data?.employee_personal_information["profile_picture"] && response.data) {
                response.data["profile_picture"] = profileResponse.data?.employee_personal_information["profile_picture"]
          }
        }


        if (response.data) {
          commit('authenticate', response.data);
        } else {
          commit('logout');
        }

        commit('loading', false);
        commit('permissionsLoading', false)

      } catch (error) {
        console.error('Authentication check failed:', error);
        // console.log("here", this.$router)
        commit('logout');
        
        // commit('loading', false);

      }
    },
    saveUserData(context, payload) {
      context.commit('saveUserData', payload)
    },

    resetState(context) {
      context.commit('reset')
    },


    loading(context, payload) {
      context.commit('loading', payload)
    },

    permissionsLoading(context, payload) {
      context.commit('permissionsLoading', payload)
    },


  },

  getters: {
    userName(state) {
      return state.user?.name || ''
    },

    userRole(state) {
      return state.user?.role || ''
    },

    userPermissions(state) {
      return state.user?.permission || []
    },

    isClientUser(state) {
      return !!state.user?.client_id
    }
  }
}